import * as React from 'react';
import styled from 'react-emotion';
const DefaultCursorLink = styled('a') `
  cursor: default;
`;
export default ({ onClick, hide = false }) => (!hide || null) && (React.createElement(DefaultCursorLink, { className: "awsui-util-help-info-link", onClick: onClick }, "Info"));
//# sourceMappingURL=HelpInfoLink.js.map